export const TEST_ID = 'modalFooterContainer';
